export default {
    props: {
      defaultClient: {
          type: Object
      },
      defaultCompanions: {
          type: Array
      }
    },
    methods:{
        setDefaultClients(){
            const vm = this
            if(vm.defaultClient){
                vm.user = vm.formatClient(vm.defaultClient)
            }else{
                vm.user = null
            }

            if(vm.defaultCompanions && vm.defaultCompanions.length > 0){
                vm.companions = vm.defaultCompanions
                    .map(user => vm.formatClient(user))
            }else{
                vm.companions = []
            }
        },
        formatClient(user){
            return {
                id: user.id,
                avatar: user.avatar,
                gender: user.gender,
                firstName: user.first_name,
                lastName: user.last_name || '',
                email: user.email || '',
                phone1: user.phone1 || '',
                phone2: user.phone2 || '',
            }
        }
    },
    watch: {
        defaultClient(){
            const vm = this
            vm.setDefaultClients()
        },
        defaultCompanions(){
            const vm = this
            vm.setDefaultClients()
        }
    }
}
